<template>
    <div class="container m-0">
        <hr>
        <div class="row text-center">
            <div class="col-md-12">
                <h3 class=" display-5"> Communities I have been associated with  </h3>
            </div>
        </div>
        <div class="row">
            <div class="col-md-2 col-4 mt-1 py-0 text-center" v-for="(item,index) in data1" :key="index">
                <a :href="item.url" target="blank"><img :src="item.img"  class="my-2 logo1" /> </a>
            </div>
        </div>
    </div>
</template>

<script>
import data1 from "@/assets/data/community.json"
export default {
    name : "communities",
    data:()=>({
        data1,
    })
    

}
</script>
<style >
.logo1
{
    width:12vh;
    border-radius:50%;
    border : 2px solid #e0e0e0;
    height: 12vh;
}
</style>